import { InputHTMLAttributes } from 'react';
import { FaCheck } from 'react-icons/fa';
import * as S from './styles';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  variant?: 'primary' | 'neutral' | 'danger';
}

/**
 * @param {boolean} readOnly makes the Checkbox not have its own click event
 */
export function Checkbox({ variant = 'neutral', ...rest }: Props) {
  return (
    <S.CheckboxWrapper $avoidClick={Boolean(rest.readOnly)} $variant={variant}>
      <S.HiddenCheckbox type="checkbox" {...rest} />
      <S.Checkbox>
        <S.Check>
          <FaCheck />
        </S.Check>
      </S.Checkbox>
    </S.CheckboxWrapper>
  );
}
